import {
  TAKING_CAR_PURCHACE_BUY_POSSIBLE_ACTIONS_BEGIN,
  TAKING_CAR_PURCHACE_BUY_POSSIBLE_ACTIONS_FAILURE,
  TAKING_CAR_PURCHACE_BUY_POSSIBLE_ACTIONS_SUCCESS
} from '../constants'
import { BFFAgent } from 'BFFAgent'

export function reducer(state, action) {
  //TODO: Diferenciar entre compra y venta
  switch (action.type) {
    case TAKING_CAR_PURCHACE_BUY_POSSIBLE_ACTIONS_BEGIN:
      return {
        takingCarManagement: {
          ...state.takingCarManagement,
          buyPossibleActionsPending: true
        }
      }
    case TAKING_CAR_PURCHACE_BUY_POSSIBLE_ACTIONS_SUCCESS:
      const possibleActionsArray = BFFAgent.Stock.TakingCarManagement.mapPossibleActionToOptions(action.data)
      return {
        takingCarManagement: {
          ...state.takingCarManagement,
          buyPossibleActions: possibleActionsArray,
          buyPossibleActionsPending: false,
        }
      }
    case TAKING_CAR_PURCHACE_BUY_POSSIBLE_ACTIONS_FAILURE:
      return {
        takingCarManagement: {
          ...state.takingCarManagement,
          buyPossibleActionsError: true,
          buyPossibleActionsPending: false
        }
      }
    default:
      return state
  }
}
